window.watchlistButton = () => {
    return {
        document: null,

        button: {
            ['@click']() {
                if (this.$store.watchlist.has(this.document.identifier)) {
                    this.$store.watchlist.remove(this.document.identifier);
                } else {
                    this.$store.watchlist.add(this.document);
                }
            },
            [':class']() {
                if (this.$store.watchlist.has(this.document.identifier)) {
                    return "watchlist-has";
                }
            }
        }
    };
}
